"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcTableNoData = function (props) {
    return (react_1.default.createElement("div", { className: "bg-apzlightblue p-6 d-flex align-items-center text-align-center justify-content-center", style: { minHeight: '470px' } },
        react_1.default.createElement("div", { className: "text-center" }, props === null || props === void 0 ? void 0 : props.children)));
};
exports.AcTableNoData = AcTableNoData;
exports.default = AcTableNoData;
AcTableNoData.displayName = 'AcTableNoData';
//# sourceMappingURL=AcTableNoData.js.map